import genericPrivacy from './generic-privacy'

export default (appName) => genericPrivacy(appName, `
<h2>Specific Privacy Policy informations related to ${appName}</h2>

<p>This MS Teams application collects informations about Teams member contacts to display it as a "tel:" url into your browser. In order to do so it has access to your teams contact data and can temporary store it in order to deliver the service.</p>
`)
